import { render, staticRenderFns } from "./HCO_details.vue?vue&type=template&id=6889916f&scoped=true"
import script from "./HCO_details.vue?vue&type=script&lang=js"
export * from "./HCO_details.vue?vue&type=script&lang=js"
import style0 from "./HCO_details.vue?vue&type=style&index=0&id=6889916f&prod&scoped=true&lang=css"
import style1 from "./HCO_details.vue?vue&type=style&index=1&id=6889916f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6889916f",
  null
  
)

export default component.exports